import { useState } from "preact/hooks";

import { api } from "@/api/client";
import type { AuthInfo, AuthMode } from "@/api/types";

export function LoginView({ mode, onLogin }: { mode: AuthMode; onLogin: (info: AuthInfo) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (): Promise<void> => {
    setBusy(true); setError("");
    try {
      const info = await api.login({ username, password, multiuser: mode.multiuser });
      setPassword("");
      onLogin(info);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "登录失败，请重试");
    } finally { setBusy(false); }
  };

  return (
    <main class="login-page">
      <form class="login-card" onSubmit={(event) => { event.preventDefault(); void submit(); }}>
        <h1>DailyResearch</h1>
        <p>{mode.multiuser ? "登录你的研究工作台" : "输入本机访问令牌"}</p>
        {mode.multiuser && <label>用户名<input autoFocus autoComplete="username" value={username} onInput={(event) => setUsername(event.currentTarget.value)} /></label>}
        <label>{mode.multiuser ? "密码" : "Access Token"}<input type="password" autoComplete="current-password" value={password} onInput={(event) => setPassword(event.currentTarget.value)} /></label>
        {error && <p class="form-error" role="alert">{error}</p>}
        <button type="submit" class="btn btn-primary" disabled={busy || (mode.multiuser && !username.trim())}>{busy ? "登录中…" : "进入"}</button>
      </form>
    </main>
  );
}
